module.exports = __webpack_public_path__ + "static/img/gggggg_32.12b7300.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_32.png
// module id = tGeB
// module chunks = 1